// Image optimization utilities for better LCP and performance

export const getImageLoadingStrategy = (
  isAboveFold: boolean = false,
  isCritical: boolean = false,
  isHero: boolean = false
): "eager" | "lazy" | undefined => {
  // Hero images and critical above-the-fold content should load immediately
  if (isHero || isCritical) {
    return "eager";
  }
  
  // Above-the-fold images should load eagerly
  if (isAboveFold) {
    return "eager";
  }
  
  // Everything else should be lazy loaded
  return "lazy";
};

export const getImageSizes = (
  breakpoint: "mobile" | "tablet" | "desktop" | "full"
): string => {
  const sizeMap = {
    mobile: "(max-width: 768px) 100vw, 50vw",
    tablet: "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw",
    desktop: "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw",
    full: "100vw"
  };
  
  return sizeMap[breakpoint];
};

export const getImageQuality = (
  isHero: boolean = false,
  isThumbnail: boolean = false
): number => {
  if (isHero) return 90;
  if (isThumbnail) return 75;
  return 85;
};
